import { SxProps, Theme } from '@mui/material';

export const formStyles: SxProps<Theme> = [
	{
		display: 'flex',
		flexDirection: 'column',
	},
];
